
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import WizardItem from '@/extend/classes/WizardItem';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeWizardItem' })

export default class storeWizardItem extends VuexModule {
  // States
  private reccords: WizardItem[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get wizardItemLoading (): boolean {
    return this.dataLoading;
  }
  private get wizardItemRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get wizardItemLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewWizardItem() {
    return (): WizardItem => { 
      return this.getWizardItem(0, true);
    }
  }

  
  public get getWizardItem () {
    return (id: number, canCreate = false): WizardItem => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id WizardItem can't be 0")
        return new WizardItem();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new WizardItem();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            WizardItem.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromWizardItem(data.reccords[0] as WizardItem);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listWizardItem (): WizardItem[] {
    return this.reccords;
  }

  public get listConfigWizardItem (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mWizardItemRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mWizardItemClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mWizardItemLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mWizardItemLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(WizardItem.fromJson(reccord as WizardItem));
    })
    WizardItem.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mWizardItemConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mWizardItemCreated (obj: WizardItem): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareWizardItem(obj)) {
          api.fromWizardItem(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareWizardItem(obj)) {
            api.fromWizardItem(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mWizardItemUpdated (obj: WizardItem): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareWizardItem(obj)) {
          api.fromWizardItem(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mWizardItemDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerWizardItem (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.wizardItemRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerWizardItem(this.wizardItemCreated, this.wizardItemUpdated, this.wizardItemDeleted);
          this.mWizardItemRegistered();
        } else {
          setTimeout(() => resolve(this.registerWizardItem(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.wizardItemLoading && !this.wizardItemLoaded) {
          this.mWizardItemLoading(true);
          return WizardItem.list(filter)
            .then((data: ListData) => {
              this.mWizardItemLoaded(data);
              this.mWizardItemLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredWizardItem (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.wizardItemLoading) {
        this.mWizardItemLoading(true);
        return WizardItem.list(filter)
          .then((data: ListData) => {
            this.mWizardItemLoaded(data);
            this.mWizardItemLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createWizardItem (obj: WizardItem): Promise<WizardItem> {
    return new Promise((resolve, reject) => {
      return WizardItem.fromJson(obj).createForStoreWizardItem()
        .then((reccords) => {
          this.mWizardItemCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateWizardItem (obj: WizardItem): Promise<WizardItem> {
    return new Promise((resolve, reject) => {
      return WizardItem.fromJson(obj).updateForStoreWizardItem()
        .then((reccords) => {
          this.mWizardItemUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteWizardItem (obj: WizardItem): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return WizardItem.fromJson(obj).deleteForStoreWizardItem()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mWizardItemDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private wizardItemCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mWizardItemConfigUpdated(config)
    const obj = objConfig.obj as WizardItem;
    this.mWizardItemCreated(WizardItem.fromJson(obj));
  }

  @Action
  private wizardItemUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mWizardItemConfigUpdated(config)
    const obj = objConfig.obj as WizardItem;
    this.mWizardItemUpdated(WizardItem.fromJson(obj));
  }

  @Action
  private wizardItemDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as WizardItem;
    this.mWizardItemDeleted(obj.id);
  }
}
